/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".field-custom[_ngcontent-%COMP%]{height:100px}\n/*# sourceMappingURL=course-entrust-student.component.css.map*/"];
export { styles as styles };
